const TopicOne = () => {
  return (
    <div className="quality-section-market">
      <div className="quality-header-market">
        <h1>Your Gateway to the Digital Economy</h1>
        <p>
          We are committed to redefine how the world learns, trades, and
          invests, creating a space where anyone can grow with confidence and
          clarity. We are here to make trading simple, transparent, and
          rewarding through education, innovation, and community-driven support.
        </p>
      </div>
    </div>
  );
};

export default TopicOne;
